
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CheckBox',

  emits: ['change'],

  props: {
    modelValue: {
      type: Boolean,
      default: false,
      required: false
    }
  }
})
